
if (!customElements.get('adev-global-popup')) {
    customElements.define('adev-global-popup', class adevGlobalPopup extends HTMLElement {
        constructor() {
            super();
            this.handleBackgroundClick = this.handleBackgroundClick.bind(this);
            this.handleCloseClick = this.handleCloseClick.bind(this);
            this.handleOpen = this.handleOpen.bind(this);
            this.handleClose = this.handleClose.bind(this);
        }

        handleBackgroundClick(event) {
            if (event.target === this) {
                document.dispatchEvent(new CustomEvent('adev:global-popup:close'));
            }
        }

        handleCloseClick(event) {
            event.preventDefault();
            document.dispatchEvent(new CustomEvent('adev:global-popup:close'));
        }

        handleOpen(event) {
            const detail = event.detail || {};
            this.classList.add('is--active');
            const titleEl = this.querySelector('[data-adev-global-popup="title"]');
            const contentEl = this.querySelector('[data-adev-global-popup="content"]');

            if (titleEl) {
                titleEl.textContent = detail.title || '';
            }

            if (contentEl) {
                contentEl.innerHTML = detail.content || '';
            }
        }

        handleClose() {
            this.classList.remove('is--active');

            setTimeout(() => {
                const titleEl = this.querySelector('[data-adev-global-popup="title"]');
                const contentEl = this.querySelector('[data-adev-global-popup="content"]');

                if (titleEl) {
                    titleEl.textContent = '';
                }

                if (contentEl) {
                    contentEl.innerHTML = '';
                }
            }, 200);
        }

        connectedCallback() {
            this.addEventListener('click', this.handleBackgroundClick);
            document.addEventListener('adev:global-popup:open', this.handleOpen);
            document.addEventListener('adev:global-popup:close', this.handleClose);

            
            const closeEl = this.querySelector('[data-adev-global-popup="close"]');
            if (closeEl) {
                closeEl.addEventListener('click', this.handleCloseClick);
            }
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.handleBackgroundClick);
            document.removeEventListener('adev:global-popup:open', this.handleOpen);
            document.removeEventListener('adev:global-popup:close', this.handleClose);
            
            const closeEl = this.querySelector('[data-adev-global-popup="close"]');
            if (closeEl) {
                closeEl.removeEventListener('click', this.handleCloseClick);
            }
        }
    });
}


if (!customElements.get('adev-open-global-popup')) {
    customElements.define('adev-open-global-popup', class adevOpenGlobalPopup extends HTMLElement {
        constructor() {
            super();
        }

        handleClick(event) {
            const title = this.getAttribute('data-popup-title');
            const contentEl = this.querySelector('[data-popup-content]');
            const content = contentEl ? contentEl.innerHTML : '';
            
            document.dispatchEvent(new CustomEvent('adev:global-popup:open', {
                detail: {
                    title: title,
                    content: content
                }
            }));
        }

        connectedCallback() {
            const openEls = this.querySelectorAll('[data-adev-open-global-popup="open"]');

            if (openEls.length > 0) {
                openEls.forEach((el) => {
                    el.addEventListener('click', this.handleClick.bind(this));
                });
            } else {
                this.addEventListener('click', this.handleClick.bind(this));
            }
        }

        disconnectedCallback() {
            const openEls = this.querySelectorAll('[data-adev-open-global-popup="open"]');

            if (openEls.length > 0) {
                openEls.forEach((el) => {
                    el.removeEventListener('click', this.handleClick.bind(this));
                });
            } else {
                this.removeEventListener('click', this.handleClick.bind(this));
            }
        }

    });
}